import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../useApi';
import { toast } from '../../../components/Toast';
import { AxiosError } from 'axios';

export function useRenameReportFile() {
  const getApi = useApi();
  const queryClient = useQueryClient();

  const mutationFn = async ({
    backgroundControlFileId,
    fileName,
  }: {
    backgroundControlFileId: string;
    fileName: string;
  }) => {
    const api = await getApi();

    const res = await api.backgroundControlsRenameReportFile(backgroundControlFileId, {
      fileName,
    });
    await queryClient.invalidateQueries();

    return res.data;
  };

  const query = useMutation({
    mutationFn,
    onSuccess: () => toast.success('Filnamnet har uppdaterats'),
    onError: (e) => toast.error(extractError(e)),
  });

  return {
    ...query,
  };
}

function extractError(e: unknown) {
  if (e instanceof AxiosError) {
    return e.response?.data?.message;
  }
  return 'Okänt fel';
}
